// extracted by mini-css-extract-plugin
export default {"label":"label-Dbxdq","dateInput":"dateInput-og4gx","placeholder":"placeholder-dtGtR","disabled":"disabled-aG3Wb","value":"value-Hhbkn","icon":"icon-wdhlG"};